import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/*
SPDX-FileCopyrightText: 2022 Genome Research Ltd.

SPDX-License-Identifier: MIT
*/
import React from "react";
import { Container } from "react-bootstrap";
import Button from "./Button";
class Header extends React.Component {
    buttons = [];
    pageEmpty = true;
    constructor(props) {
        super(props);
        if (props.buttons !== undefined) {
            this.buttons = props.buttons;
        }
        if (props.pageEmpty === undefined) {
            this.pageEmpty = false;
        }
    }
    render() {
        return (_jsxs("div", { children: [_jsx("div", { className: "header", children: _jsx("header", { className: "masthead text-center text-white", children: _jsxs("div", { className: "masthead-content", children: [_jsx("li", {}), _jsx("li", {}), _jsx("li", {}), _jsx("li", {}), _jsx("li", {}), _jsx("li", {}), _jsx("li", {}), _jsx("li", {}), _jsx("li", {}), _jsx("li", {}), _jsxs(Container, { children: [_jsx("div", { className: "navbar-filler" }), _jsx("h1", { className: "masthead-heading mb-0", children: this.props.title }), _jsx("h2", { className: "masthead-subheading mb-0", children: this.props.subTitle }), this.buttons.map((button) => (_jsx("div", { style: { marginTop: "30px" }, children: _jsx(Button, { text: button.text, onClick: () => {
                                                    window.location.href = button.href;
                                                } }) }, button.text)))] })] }) }) }), this.pageEmpty ? _jsx("h6", { children: "\u200E" }) : _jsx(_Fragment, {})] }));
    }
}
export default Header;
